import { render, staticRenderFns } from "./reveal.vue?vue&type=template&id=4abb020a&"
import script from "./reveal.vue?vue&type=script&lang=js&"
export * from "./reveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports